import { PREVIOUS_YEAR_SEGMENTS } from "./constants";
import type { PreviousYearSegmentOption } from "./types";

/**
 * Build the previous-year dropdown option list for a given year.
 *
 * The list is identical for any prior year (12 months + 4 quarters). Each
 * label is suffixed with the `year` (e.g. "January 2024", "Q1 2024") to match
 * the existing Leaderboards UX and give the option list unambiguous meaning
 * when several years are displayed side by side.
 */
export const getPreviousYearOptions = (year: number): PreviousYearSegmentOption[] => {
  return PREVIOUS_YEAR_SEGMENTS.map((segment) => ({ ...segment, label: `${segment.label} ${year}` }));
};
